module.exports = __webpack_public_path__ + "static/media/via.af8111b2.jpeg";